export const MATERIAL_SCOPE_TEXTS = {
  project: 'Vivienda',
  articleSearch: 'Material',
  destinationContains: 'Destino contiene',
  projectPlaceholder: 'Buscar vivienda',
  articlePlaceholder: 'Código o nombre',
  noProjects: 'Sin viviendas',
  noArticles: 'Sin resultados (escribí al menos 3 caracteres)',
};
